/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Privacy_IntroInputs */

const fr_legal_privacy_intro = /** @type {(inputs: Legal_Privacy_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog EU collecte pour Bus Tracker les données suivantes à des fins d'analyse de la fréquentation et d'aide à la résolution des anomalies :`)
};

const en_legal_privacy_intro = /** @type {(inputs: Legal_Privacy_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostHog EU collects the following data for Bus Tracker to analyze usage and help resolve issues:`)
};

/**
* | output |
* | --- |
* | "PostHog EU collects the following data for Bus Tracker to analyze usage and help resolve issues:" |
*
* @param {Legal_Privacy_IntroInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_privacy_intro = /** @type {((inputs?: Legal_Privacy_IntroInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Privacy_IntroInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_privacy_intro(inputs)
	return en_legal_privacy_intro(inputs)
});